import { render, staticRenderFns } from "./Frontend.vue?vue&type=template&id=2f528238"
import script from "./Frontend.vue?vue&type=script&lang=js"
export * from "./Frontend.vue?vue&type=script&lang=js"
import style0 from "./Frontend.vue?vue&type=style&index=0&id=2f528238&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports